export default "__VITE_ASSET__e3cd516e__"